// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"ac6994ac","75":"cbf0af6b","378":"18ce6e9f","607":"08e57541","661":"72373663","737":"b8554fed","923":"bc380ca8","926":"8a949080"}[chunkId] + ".chunk.js";
};